import Head from 'next/head';
import { useRouter } from 'next/router';
import config from 'utils/config';
import HotjarScript from 'components/HotjarScript';
import { appHostProd } from 'utils/constants';

type HeadProps = {
  title?: string;
  keywords?: string;
  description?: string;
  titleOg?: string;
  descriptionOg?: string;
  imageUrl?: string;
  hostUrl?: string;
  author?: string;
  robots?: string;
  googleBot?: string;
  children?: React.ReactNode;
  schemaJson?: Record<string, any>;
};


export default function MainHead({
  title: titleProp,
  keywords,
  author,
  description,
  titleOg,
  descriptionOg,
  imageUrl,
  robots,
  googleBot,
  children,
  schemaJson,
}: HeadProps) {
  const { asPath } = useRouter();
  const domainConfig = config.cookiesConfig.domain;
  const isDomainProd = domainConfig === appHostProd;
  const title = titleProp || 'OnBoard Crew App | Portal Lowongan Kerja dan Karier Untuk Pelaut';
  const facebookTitle = titleOg || title;
  const facebookDescription = descriptionOg || description || 'Raih Karier Pelaut Impianmu!';
  const twitterDescription = facebookDescription;
  const imageMeta = imageUrl || 'https://directus.onboardcrewapp.com/assets/eaf53392-2f9a-49cc-8434-6c7ca1381b85';

  function trimBackSlash(v: string) {
    return v.endsWith('/') ? v.substring(0, v.length - 1) : v;
  };

  return (
    <Head>
      <title>{title}</title>

      <link rel='icon' type='image/png' href='/favicons/favicon-96x96.png' sizes='96x96' />
      <link rel='icon' type='image/svg+xml' href='/favicons/favicon.svg' />
      <link rel='shortcut icon' href='/favicons/favicon.ico' />
      <link rel='apple-touch-icon' sizes='180x180' href='/favicons/apple-touch-icon.png' />
      <meta name='apple-mobile-web-app-title' content='OnBoard Crew App' />
      <link rel='manifest' href='/favicons/site.webmanifest' />

      <link rel='canonical' href={trimBackSlash(`https://${domainConfig}${asPath}`)} />

      <meta name='title' content={title} />
      {author && <meta name='author' content={author} />}
      {keywords && <meta name='keywords' content={keywords} />}
      <meta name='description' content={facebookDescription} />

      <meta property='og:title' content={facebookTitle} />
      <meta property='og:image' content={imageMeta} />
      <meta property='og:description' content={facebookDescription} />
      <meta property='og:site_name' content='OnBoard Crew App' />
      <meta property='og:type' content='website' />

      <meta name='twitter:description' content={twitterDescription} />
      <meta name='twitter:title' content={facebookTitle} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:image' content={imageMeta} />

      {robots && <meta name='robots' content={robots} />}
      {googleBot && <meta name='googlebot' content={googleBot} />}

      {isDomainProd && (
        <HotjarScript />
      )}

      {schemaJson && (
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaJson) }}
        />
      )}

      {children}
    </Head>
  )
}
